<template>
    <transition :name="$route.meta.transition || 'fade'">
        <div class="bg-cover" :style="'background-image: url(' + $asset('/hkcm/images/auth.png', 'public') + ')'">
            <div class="min-h-screen container mx-auto flex items-center justify-center">
                <div class="bg-white w-full lg:w-7/12 rounded-md my-12">
                    <div
                        class="bg-white text-blue-dark mx-auto w-full transition-all ease-in-out duration-300 rounded-md p-4 lg:p-16 flex flex-col justify-center items-center lg:w-3/4"
                    >
                        <div class="text-center mb-8">
                            <h1 class="text-sm md:text-2xl">{{ $t('Please Logout to verify user') }}</h1>
                            <div class="mt-4">
                                <button class="bg-blue-dark text-white font-bold py-2 px-4 rounded-md text-sm" @click="[store.dispatch('user/logout')]">
                                    {{ $t('Logout') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup>
import { store } from '../store';

const url = new URLSearchParams(window.location.search).get('url');
sessionStorage.setItem('url', url);
</script>
